module.exports = "/_next/static/images/6c027ee866d3c7606f1945b75ea06d73-office@3x.jpg";